export default __webpack_public_path__ + "static/media/es-ca.a03129ff.svg";